import React from 'react';
import {
    // Theme,
    theme,
    actionTheme
} from "./theme/index";
import Svg from './svg/index';
import Button from './button/button';
import ButtonField from './button/buttonField';
import Dialog from './dialog/dialog';
import PreviewImage from './previewImage/previewImage';
import {
    GlobalLoading,
    PartLoading
} from './loding/index';

import Page from './page/page';
import Message from './message/message';
import Tip from './tip/tip';
import {
    GridField,
    Tr,
    Td,

    gridRows,
    selectFlag,
    selectItem,
    selectAll,

    actionGrid,
} from './grid/index';

import ScrollBox1 from './scroll/scrollBox1.0';
import ScrollBox from './scroll/scrollBox2.0';

import {
    InputField,
    NumberField,
    TextareaField,
    RadioField,
    CheckboxField,
    SelectField,
    SelectCheckboxField,
    SelectLenovoField,
    SelectLenovoCheckboxField,
    DateField,
    DateTimeField,
    DateRangeField,
    DateWeekField,
    TimeField,
    OrganizationTreeField,

    formData,
    subVerifyRes,
    actionForm
} from "./form/index";

import {
    Personnel,
    DepartmentStaff,
    personnelList,
    choosePerson,
    deptPerson,

    actionPerson
} from "./person/index";

import DeptPersonnel from "./deptPersonnel/index"
 
//第一代表格
import TableField from "./table/table1.0/table";
//第二代表格
import LockTableField from "./table/table2.0/table";
//第三代表格
import DragTableField from "./table/table3.0/table";

import {_Platform, _Cache, _Ajax, _Tree, _Object, _Date, _Array, _Check} from  "./utils/utils";
const _utils = {_Platform, _Cache, _Ajax, _Tree, _Object, _Date, _Array, _Check};

export {
    //主题
    theme,//store
    actionTheme,//action

    //图标
    Svg,
    //按钮
    Button,
    ButtonField,
    //弹框
    Dialog,
    //预览图片
    PreviewImage,

    //全局loading
    GlobalLoading,
    //局部loading
    PartLoading,

    //分页
    Page,
    Message,
    //grid
    GridField,
    Tr,
    Td,
    gridRows,//store
    selectFlag,//store
    selectItem,//store
    selectAll,//store
    actionGrid,//action
    //气泡提示框
    Tip,
    //滚动条
    ScrollBox1,
    ScrollBox,

    //表单
    InputField,
    NumberField,
    TextareaField,
    RadioField,
    CheckboxField,
    SelectField,
    SelectCheckboxField,
    SelectLenovoField,
    SelectLenovoCheckboxField,
    DateField,
    DateTimeField,
    DateRangeField,
    DateWeekField,
    TimeField,
    OrganizationTreeField,
    formData,//store
    subVerifyRes,//store
    actionForm,//action

    //选择人员
    Personnel,
    DepartmentStaff,
    DeptPersonnel,
    personnelList,//store
    choosePerson,//store
    deptPerson,//store
    actionPerson,//action


    //表格
    TableField,
    LockTableField,
    DragTableField,

    _utils,


}